import { useEffect, useState } from 'react'
import { useInterval } from 'ahooks';
import { Radio, DatePicker, Button } from 'antd';
import FontIcon from "@/components/YhIcon";
import { SettingOutlined } from '@ant-design/icons'
import type { RangePickerProps } from 'antd/es/date-picker';
import { moneyFormat } from "@/utils/utils";
import { TradeLine } from './TradeLine'
import { TurnoverPie } from './TurnoverPie'
import { InventoryPie } from './InventoryPie'
import { InvoiceBar } from './InvoiceBar'
import { HomeModel } from './HomeModel'
import useNavModel from '@/model/navModel'
import moment from 'moment';
import './home2.less';
import styled from '@emotion/styled';
import HeaderIcon1 from '@/assets/images/home/index-header-icon1.png'
import HeaderIcon2 from '@/assets/images/home/index-header-icon2.png'
import HeaderIcon3 from '@/assets/images/home/index-header-icon3.png'
import HeaderIcon4 from '@/assets/images/home/index-header-icon4.png'
import HeaderIcon5 from '@/assets/images/home/index-header-icon5.png'
import HeaderIcon6 from '@/assets/images/home/index-header-icon6.png'

export const Home2 = () => {

  const {
    loadAll, loadStatistics,
    requestTime, statistics, inventoryAmount, schedule,
    turnoverPieData, tradeLineData, inventoryPieData, InvoiceBarData,
    setShortcutVisible,
    checkValues, optionsList,exportAmountList,exportLoading
  } = HomeModel();

  const { addNav } = useNavModel();
  const [timeRadioValue, setTimeRadioValue] = useState<string>("all");

  useEffect(() => {
    loadAll({});
  }, [])

  useInterval(() => {
    loadAll({});
  }, 60000);

  const handleTimeRadio = (value: string) => {
    setTimeRadioValue(value);

    if (value == "today") {
      let start = moment().startOf('day').format('YYYY-MM-DD HH:mm:ss');
      let end = moment().endOf('day').format('YYYY-MM-DD HH:mm:ss');
      loadStatistics({ "startTime": start, "endTime": end });
    }else if (value == "yesterday") {
      let end = moment().subtract(1, "days").format("YYYY-MM-DD 23:59:59"); //当前时间的前10天时间;
      loadStatistics({ "startTime": "", "endTime": end });
    }
    else {
      loadStatistics({ "startTime": "", "endTime": "" });
    }
  };

  const fillArray = (arr: any[], length: number, fill: any) => {
    let newArr = [...arr];
    if (newArr.length < length) {
      var diff = length - arr.length;
      for (var i = 0; i < diff; i++) {
        newArr.push(fill);
      }
    }
    return newArr;
  }

  return (
    <div className='home-container2'>
      <div className='home-line-space'></div>
      <div className='home-top'>
        <div className='home-top-radio'>
          <Radio.Group buttonStyle="solid" defaultValue={timeRadioValue} onChange={(e) => handleTimeRadio(e.target.value)} >
            <Radio.Button value="all">全部</Radio.Button>
            {/* <Radio.Button value="today">当日</Radio.Button>
            <Radio.Button value="yesterday">昨日</Radio.Button> */}
          </Radio.Group>
        </div>
        <div className='home-top-timepick'>
          {/* <DatePicker.RangePicker
            value={[
              startTime != "" ? moment(startTime, 'YYYY-MM-DD HH:mm:ss') : null,
              endTime != "" ? moment(endTime, 'YYYY-MM-DD HH:mm:ss') : null
            ]}
            onChange={handleDatePicker} /> */}
        </div>
        <div className='home-top-timestr'>
        <Button  className="mr-5" type="link" shape="round" loading={exportLoading} onClick={() => exportAmountList()} style={{marginRight:'10px'}}>导出</Button>
          {requestTime}
        </div>
      </div>
      <div className='home-line-space'></div>
      <div className='home-static'>
        {/* <div className='home-static-child'>
          <div className='home-static-child-icon'>
            <img src={require("../../../../assets/images/home/home-static-icon1.png").default}></img>
          </div>
          <div className='home-static-child-content'>
            <span className='home-static-child-content-amount'>{moneyFormat(statistics?.turnoverAmount ?? 0).slice(0, -3)}</span>
            <span className='home-static-child-content-float'>{moneyFormat(statistics?.turnoverAmount ?? 0).slice(-3)}</span>
            <br />
            <span className='home-static-child-content-title'>营业额</span>
          </div>
        </div>
        <div className='home-static-child'>
          <div className='home-static-child-icon'>
            <img src={require("../../../../assets/images/home/home-static-icon2.png").default}></img>
          </div>
          <div className='home-static-child-content'>
            <span className='home-static-child-content-amount'>{moneyFormat(statistics?.receivableAmount ?? 0).slice(0, -3)}</span>
            <span className='home-static-child-content-float'>{moneyFormat(statistics?.receivableAmount ?? 0).slice(-3)}</span>
            <br />
            <span className='home-static-child-content-title'>应收金额</span>
          </div>
        </div>
        <div className='home-static-child'>
          <div className='home-static-child-icon'>
            <img src={require("../../../../assets/images/home/home-static-icon3.png").default}></img>
          </div>
          <div className='home-static-child-content'>
            <span className='home-static-child-content-amount'>{moneyFormat(statistics?.payableAmount ?? 0).slice(0, -3)}</span>
            <span className='home-static-child-content-float'>{moneyFormat(statistics?.payableAmount ?? 0).slice(-3)}</span>
            <br />
            <span className='home-static-child-content-title'>应付金额</span>
          </div>
        </div>
        <div className='home-static-child'>
          <div className='home-static-child-icon'>
            <img src={require("../../../../assets/images/home/home-static-icon4.png").default}></img>
          </div>
          <div className='home-static-child-content'>
            <span className='home-static-child-content-amount'>{moneyFormat(statistics?.proceedsAmount ?? 0).slice(0, -3)}</span>
            <span className='home-static-child-content-float'>{moneyFormat(statistics?.proceedsAmount ?? 0).slice(-3)}</span>
            <br />
            <span className='home-static-child-content-title'>收款金额</span>
          </div>
        </div>
        <div className='home-static-child'>
          <div className='home-static-child-icon'>
            <img src={require("../../../../assets/images/home/home-static-icon5.png").default}></img>
          </div>
          <div className='home-static-child-content'>
            <span className='home-static-child-content-amount'>{moneyFormat(inventoryAmount ?? 0).slice(0, -3)}</span>
            <span className='home-static-child-content-float'>{moneyFormat(inventoryAmount ?? 0).slice(-3)}</span>
            <br />
            <span className='home-static-child-content-title'>库存金额</span>
          </div>
        </div>
        <div className='home-static-child'>
          <div className='home-static-child-icon'>
            <img src={require("../../../../assets/images/home/home-static-icon6.png").default}></img>
          </div>
          <div className='home-static-child-content'>
            <span className='home-static-child-content-amount'>{moneyFormat(statistics?.invoiceAmount ?? 0).slice(0, -3)}</span>
            <span className='home-static-child-content-float'>{moneyFormat(statistics?.invoiceAmount ?? 0).slice(-3)}</span>
            <br />
            <span className='home-static-child-content-title'>开票金额</span>
          </div>
        </div> */}
        <Item style={{ background: 'linear-gradient(135deg, #FF9C27 0%, #F5B013 100%)' }}>
          <img src={HeaderIcon1} />
          <div className="index-header-title">营业额</div>
          <div className="index-header-content">
            <span className='home-static-child-content-amount'>{moneyFormat(statistics?.turnoverAmount ?? 0).slice(0, -3)}</span>
            <span className='home-static-child-content-float'>{moneyFormat(statistics?.turnoverAmount ?? 0).slice(-3)}</span>
          </div>
        </Item>
        <Item style={{ background: 'linear-gradient(315deg, #09C3D5 0%, #22B4D8 100%)' }}>
          <img src={HeaderIcon2} />
          <div className="index-header-title">应收金额</div>
          <div className="index-header-content">
            <span className='home-static-child-content-amount'>{moneyFormat(statistics?.receivableAmount ?? 0).slice(0, -3)}</span>
            <span className='home-static-child-content-float'>{moneyFormat(statistics?.receivableAmount ?? 0).slice(-3)}</span>
          </div>
        </Item>
        <Item style={{ background: 'linear-gradient(134deg, #FF5252 0%, #FF7954 100%)' }}>
          <img src={HeaderIcon3} />
          <div className="index-header-title">现金待付款金额</div>
          <div className="index-header-content">
            <span className='home-static-child-content-amount'>{moneyFormat(statistics?.payableAmount ?? 0).slice(0, -3)}</span>
            <span className='home-static-child-content-float'>{moneyFormat(statistics?.payableAmount ?? 0).slice(-3)}</span>
          </div>
        </Item>
        <Item style={{ background: 'linear-gradient(315deg, #6C6CFC 0%, #6161F8 100%)' }}>
          <img src={HeaderIcon4} />
          <div className="index-header-title">现金待收款金额 </div>
          <div className="index-header-content">
            <span className='home-static-child-content-amount'>{moneyFormat(statistics?.proceedsAmount ?? 0).slice(0, -3)}</span>
            <span className='home-static-child-content-float'>{moneyFormat(statistics?.proceedsAmount ?? 0).slice(-3)}</span>
          </div>
        </Item>
        <Item style={{ background: 'linear-gradient(314deg, #ff9292 0%, #ff6b6d 100%)' }}>
          <img src={HeaderIcon5} />
          <div className="index-header-title">三个月未回款金额</div>
          <div className="index-header-content">
            <span className='home-static-child-content-amount'>{moneyFormat(statistics?.threeMonthReceiveAmount ?? 0).slice(0, -3)}</span>
            <span className='home-static-child-content-float'>{moneyFormat(statistics?.threeMonthReceiveAmount ?? 0).slice(-3)}</span>
          </div>
        </Item>
        <Item style={{ background: 'linear-gradient(314deg, #2CD8A0 0%, #1EC189 100%)' }}>
          <img src={HeaderIcon5} />
          <div className="index-header-title">库存金额</div>
          <div className="index-header-content">
            <span className='home-static-child-content-amount'>{moneyFormat(inventoryAmount ?? 0).slice(0, -3)}</span>
            <span className='home-static-child-content-float'>{moneyFormat(inventoryAmount ?? 0).slice(-3)}</span>
          </div>
        </Item>
        <Item style={{ background: 'linear-gradient(301deg, #6AA1FF 0%, #3985FF 100%)' }}>
          <img src={HeaderIcon6} />
          <div className="index-header-title">开票金额</div>
          <div className="index-header-content">
            <span className='home-static-child-content-amount'>{moneyFormat(statistics?.invoiceAmount ?? 0).slice(0, -3)}</span>
            <span className='home-static-child-content-float'>{moneyFormat(statistics?.invoiceAmount ?? 0).slice(-3)}</span>
          </div>
        </Item>
      </div >
      <div className='home-line-space'></div>
      <div className='home-middle'>
        <div className='home-schedule'>
          <div className='home-schedule-title'>
            待办事项
          </div>
          {/* <div className='home-schedule-horizontal'></div>
          <div className='home-schedule-vertical'></div>
          <div className='home-schedule-content'>
            <div className='home-schedule-content-child'>
              <div className='home-schedule-content-child-amount' style={{ color: '#5A7FFF' }}>
                {schedule?.receiptNum ?? 0}
              </div>
              <div className='home-schedule-content-child-title'>
                现金待收款
              </div>
            </div>
            <div className='home-schedule-content-child'>
              <div className='home-schedule-content-child-amount' style={{ color: '#41CBD6' }}>
                {schedule?.paymentNum ?? 0}
              </div>
              <div className='home-schedule-content-child-title'>
                现金待付款
              </div>
            </div>
            <div className='home-schedule-content-child'>
              <div className='home-schedule-content-child-amount'>
                {schedule?.rechargeNum ?? 0}
              </div>
              <div className='home-schedule-content-child-title'>
                充值待审
              </div>
            </div>
            <div className='home-schedule-content-child'>
              <div className='home-schedule-content-child-amount'>
                {schedule?.adjustNum ?? 0}
              </div>
              <div className='home-schedule-content-child-title'>
                调额待审
              </div>
            </div>
          </div> */}
          <button className='home-schedule-button' onClick={() => { addNav("5-1", { id: '代收', mode: '' }) }}>
            <div className='home-static-child'>
              {/* <div className='home-static-child-icon'>
            <img src={require("../../../../assets/images/home/税务代理备份.png").default}></img>
          </div> */}
              <div className='home-static-child-content'>
                <span className='home-static-child-content-amount'>现金待收款</span>
                <br />
                <span className='home-static-child-content-float'>{schedule?.receiptNum ?? 0}</span>
                <br />
                <span className='home-static-child-content-title'>点击进入收款列表→</span>
              </div>
            </div>
          </button>
          <button className='home-schedule-button' onClick={() => { addNav("5-2", { id: '待付', mode: '' }) }}>
            <div className='home-static-child'>
              {/* <div className='home-static-child-icon'>
            <img src={require("../../../../assets/images/home/历史工单.png").default}></img>
          </div> */}
              <div className='home-static-child-content'>
                <span className='home-static-child-content-amount'>现金待付款</span>
                <br />
                <span className='home-static-child-content-float'>{schedule?.paymentNum ?? 0}</span>
                <br />
                <span className='home-static-child-content-title'>点击进入付款列表→</span>
              </div>
            </div>
          </button>
          <button className='home-schedule-button' onClick={() => { addNav("9-6", { id: '待审核', mode: '' }) }}>
            <div className='home-static-child'>
              {/* <div className='home-static-child-icon'>
            <img src={require("../../../../assets/images/home/应收报表.png").default}></img>
          </div> */}
              <div className='home-static-child-content'>
                <span className='home-static-child-content-amount' >充值待审</span>
                <br />
                <span className='home-static-child-content-float'>{schedule?.rechargeNum ?? 0}</span>

              </div>
            </div>
          </button>
          <button className='home-schedule-button' onClick={() => { addNav("9-7", { id: '待审核', mode: '' }) }}>
            <div className='home-static-child'>
              {/* <div className='home-static-child-icon'>
            <img src={require("../../../../assets/images/home/内部核算单位.png").default}></img>
          </div> */}
              <div className='home-static-child-content'>
                <span className='home-static-child-content-amount'>调额待审</span>
                <br />
                <span className='home-static-child-content-float'> {schedule?.adjustNum ?? 0}</span>

              </div>
            </div>
          </button>
        </div>
        <div className='home-turnover'>
          {/* {TurnoverPie && <TurnoverPie data={turnoverPieData} />} */}
          {TurnoverPie && <TurnoverPie
            xData={turnoverPieData?.map(e => e.tradeTypeName?.substring(0, 8))}
            yData={[turnoverPieData?.map(e => e.amount), turnoverPieData?.map(e => e.receiveAmount)]}
          />}
        </div>
        <div className='home-inventory'>
          {InventoryPie && <InventoryPie data={inventoryPieData} />}
        </div>
      </div >
      <div className='home-line-space'></div>
      <div className='home-bottom'>
        <div className='home-shortcut'>
          <div className='home-shortcut-title'>
            快捷方式
            <div className='home-shortcut-setting'>
              <span onClick={() => { setShortcutVisible(true) }}><SettingOutlined /></span>
            </div>
          </div>
          <div style={{ width: 1, height: '5%' }}></div>
          <div className='home-shortcut-content'>
            {checkValues.length !== 0 ?
              <>
                {fillArray(checkValues, 9, { "icon": "", "name": "" })?.map((item: { id: string, name: string, url: string, path: string, icon: string }) =>
                  <div className='home-shortcut-content-child'>
                    <div className='home-shortcut-content-child-icon'>
                      <FontIcon type={item.icon} onClick={() => { addNav(item.path) }} />
                    </div>
                    <div className='home-shortcut-content-child-title'>
                      {item.name}
                    </div>
                  </div>
                )}
              </>
              :
              <>
                {optionsList.slice(0, 9)?.map((item: { id: string, name: string, url: string, path: string, icon: string }) =>
                  <div className='home-shortcut-content-child'>
                    <div className='home-shortcut-content-child-icon'>
                      <FontIcon type={item.icon} onClick={() => { addNav(item.path) }} />
                    </div>
                    <div className='home-shortcut-content-child-title'>
                      {item.name}
                    </div>
                  </div>
                )}
              </>
            }
          </div>
        </div>
        <div className='home-business-sale'>
          {TradeLine && <TradeLine
            xData={tradeLineData?.map(e => e.monthly?.substring(5, e.monthly.length).replace(/\b(0+)/gi, "") + '月')}
            yData={[tradeLineData?.map(e => e.turnoverAmount), tradeLineData?.map(e => e.receiptAmount)]}
          />}
        </div>
        <div className='home-business-invoice'>
          {InvoiceBar && <InvoiceBar data={InvoiceBarData} />}
        </div>
      </div>
      <div className='home-line-space'></div>
    </div>
  )
}

const Item = styled.div`
    flex: 1;
    padding-left: 24px;
    margin-right: 16px;
    border-radius: 4px;
    position: relative;
    min-width: 13% ;
    &:last-child {
        margin-right: 0;
    }
    img {
        position: absolute;
        bottom: 0;
        right: 0;
        width: 76px;
        height: 68px;
    }
    }
    .index-header-title {
        font-size: 1vw;
        font-weight: bolder !important;
        color: #fff !important;
        line-height: 30px;
        margin-top: 10%;
    }
    .index-header-content {
      margin-top: 10px;
        font-size: 0.7vw;
        color: rgba(255,255,255,0.6);
        line-height: 20px;
        // span {
        //     color: rgba(255,255,255,1);
        //     font-size: 0.5vw;
        //     font-weight: bold;
        //     margin-left: 8px;
        // }
        .home-static-child-content-amount{
          font-size: 130%;
          font-weight: bold;
          color: #FFFFFF;
        }
        .home-static-child-content-float{
          font-size:0.6vw;
          font-weight: bold;
          color: #FFFFFF;
        }
        .home-static-child-content-title{
          font-size:16px;
          font-weight: normal;
          color: #FFFFFF;
        }
    }
`